import { Directive, HostListener, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControlDirective, FormControlName, NgControl } from '@angular/forms';
import { roundTo } from '@assetaccountant/core/utils/numeric.utils';
import {
  BehaviorSubject,
  combineLatest,
  distinctUntilChanged,
  filter,
  map,
  SubscriptionLike,
} from 'rxjs';

@Directive({
  selector: '[formControl][precision], [formControlName][precision]',
  standalone: false,
})
export class PrecisionDirective implements OnInit, OnDestroy {
  @Input() set precision(value: number) {
    this._precision$.next(+value);
  }

  private _precision$ = new BehaviorSubject(0);
  private _hasFocus$ = new BehaviorSubject(false);
  private _subscriptions: SubscriptionLike[] = [];

  constructor(@Inject(NgControl) private control: FormControlDirective | FormControlName) {}

  ngOnInit() {
    const numericValue$ = this.control.control.valueChanges.pipe(
      distinctUntilChanged(),
      map(value => parseFloat(value)),
      filter(value => isFinite(value)),
    );

    this._subscriptions.push(
      combineLatest([numericValue$, this._precision$, this._hasFocus$])
        .pipe(filter(([, , hasFocus]) => !hasFocus))
        .subscribe(([value, precision]) => {
          const roundedValue = roundTo(value, precision);
          if (roundedValue !== +value) {
            this.control.control.setValue(roundedValue);
          }
        }),
    );
  }

  ngOnDestroy() {
    this._subscriptions.forEach(s => s.unsubscribe());
  }

  @HostListener('focus')
  onFocus() {
    this._hasFocus$.next(true);
  }

  @HostListener('blur')
  onBlur() {
    this._hasFocus$.next(false);
  }
}
